import { createClient } from '@connectrpc/connect';
import { createConnectTransport } from '@connectrpc/connect-web';
import { SegmentService } from '@buf/alconostmt_services.bufbuild_es/alconost/mt/segment_pb.js';

// Create a transport
const transport = createConnectTransport({
    baseUrl: 'https://services-375925469890.us-central1.run.app',
});

// Create a client
const segmentClient = createClient(SegmentService, transport);

// Add segments to an evaluation
export const addSegments = async (evaluationId, segments) => {
    try {
        // Transform segments to the format expected by the API
        const segmentInputs = segments.map((segment, index) => ({
            segmentNumber: index + 1,
            sourceText: segment.source,
            targetText: segment.target
        }));

        const request = {
            evaluationId,
            segments: segmentInputs
        };

        const response = await segmentClient.addSegments(request);
        console.log('Add segments response:', response);
        return response.segments;
    } catch (error) {
        console.error('Error adding segments:', error);
        throw error;
    }
};

// Get segments for an evaluation
export const getSegments = async (
    evaluationId,
    minScore = 1,
    maxScore = 100,
    searchTerm = '',
    pageSize = 10,
    pageNumber = 1
) => {
    try {
        const request = {
            evaluationId,
            minScore,
            maxScore,
            searchTerm,
            pageSize,
            pageNumber
        };

        const response = await segmentClient.getSegments(request);
        return response;
    } catch (error) {
        console.error('Error getting segments:', error);
        throw error;
    }
};

// Update segments
export const updateSegments = async (request) => {
    try {
        const response = await segmentClient.updateSegments(request);
        console.log('Update segments response:', response);
        return response.segments;
    } catch (error) {
        console.error('Error updating segments:', error);
        throw error;
    }
};

// Delete segments
export const deleteSegments = async (evaluationId, segmentIds) => {
    try {
        console.log('Deleting segments with request:', {
            evaluation_id: evaluationId,
            segment_ids: segmentIds
        });

        const request = {
            evaluationId: evaluationId,
            segmentIds: segmentIds
        };

        const response = await segmentClient.deleteSegments(request);
        return response;

    } catch (error) {
        console.error('Error deleting segments:', error);
        throw error;
    }
};

// Get segment errors
export const getSegmentErrors = async (segmentIds) => {
    try {
        const response = await segmentClient.getSegmentErrors({ segmentIds });
        return response.errors;
    } catch (error) {
        console.error('Error getting segment errors:', error);
        throw error;
    }
};